import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorLayout from './ErrorLayout';
import { withRouter } from 'react-router-dom';
import AppContext from '../../AppContext';

const SafeNavigation = (props) => {
  const context = useContext(AppContext);
  const {
    actions,
    state: { theme, footer, contentFooter, transactionToken, hasError, errorMessage }
  } = context;
  const { pathname } = props.location;

  useEffect(() => {
    if ((!transactionToken || transactionToken.length <= 0) && pathname !== '/') {
      const exceptionData = {
        theme,
        footer,
        contentFooter
      };
      actions.resetState(exceptionData); // Reset localState
      location.href = '/'; // TODO revoke
    }
  }, [transactionToken, pathname]);

  if (hasError) {
    return <ErrorLayout />;
  }

  return <div className="safe-navigation"></div>;
};

export default withRouter(SafeNavigation);
